'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('selectors/statistics');

var _PopularityChart = require('components/Statistics/PopularityChart/PopularityChart');

var _PopularityChart2 = _interopRequireDefault(_PopularityChart);

var _statistics3 = require('helpers/statistics');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _RecipientStatisticsTabs = require('components/Statistics/RecipientStatisticsTabs/RecipientStatisticsTabs');

var _RecipientStatisticsTabs2 = _interopRequireDefault(_RecipientStatisticsTabs);

var _SimpleTabContent = require('components/SimpleTabContent/SimpleTabContent');

var _SimpleTabContent2 = _interopRequireDefault(_SimpleTabContent);

var _RecipientDetailedStatsList = require('components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsList');

var _RecipientDetailedStatsList2 = _interopRequireDefault(_RecipientDetailedStatsList);

var _StatisticsSelectedRecipientInfo = require('components/Statistics/StatisticsSelectedRecipientInfo/StatisticsSelectedRecipientInfo');

var _StatisticsSelectedRecipientInfo2 = _interopRequireDefault(_StatisticsSelectedRecipientInfo);

var _network = require('helpers/network');

var _StatisticsRecipientBackButton = require('components/Statistics/StatisticsRecipientBackButton/StatisticsRecipientBackButton');

var _StatisticsRecipientBackButton2 = _interopRequireDefault(_StatisticsRecipientBackButton);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _StatisticsSelectedProjectInfo = require('components/Statistics/StatisticsSelectedProjectInfo/StatisticsSelectedProjectInfo');

var _StatisticsSelectedProjectInfo2 = _interopRequireDefault(_StatisticsSelectedProjectInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectRecipientStatistics.scss');

var ProjectRecipientStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        recipientId = _ref$params.recipientId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadPopularityStats({ projectId: projectId, recipientId: recipientId })).promise);
  }
}, {
  promise: function promise(_ref2) {
    var dispatch = _ref2.store.dispatch,
        _ref2$params = _ref2.params,
        projectId = _ref2$params.projectId,
        recipientId = _ref2$params.recipientId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipientDetailedStats({ projectId: projectId, recipientId: recipientId })).promise);
  }
}, {
  promise: function promise(_ref3) {
    var dispatch = _ref3.store.dispatch,
        projectId = _ref3.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadCoverageStats({ projectId: projectId })).promise);
  }
}, {
  promise: function promise(_ref4) {
    var dispatch = _ref4.store.dispatch,
        projectId = _ref4.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadProjectInfo({ projectId: Number(projectId) })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    endDate: state.statistics.endDate,
    detailedData: (0, _statistics2.getRecipientDetailedData)(state),
    popularityData: (0, _statistics2.getPopularityData)(state, true),
    popularityLoading: state.statistics.popularityStatsLoading,
    projectId: Number(ownProps.params.projectId),
    projectInfo: (0, _statistics2.getProjectInfo)(state),
    projectInfoLoading: state.statistics.projectInfoLoading,
    detailedLoading: state.statistics.recipientDetailedStatsLoading,
    recipient: (0, _statistics2.getCoverageDataRecipient)(state, Number(ownProps.params.recipientId)),
    recipientId: Number(ownProps.params.recipientId),
    referrer: (0, _network.getRoutesLastParam)({ routes: ownProps.routes, name: 'referrer' }),
    referrerRecipient: Number(ownProps.location.query.referrerRecipient),
    startDate: state.statistics.startDate
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectRecipientStatistics, _Component);

  function ProjectRecipientStatistics() {
    var _ref5;

    (0, _classCallCheck3.default)(this, ProjectRecipientStatistics);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref5 = ProjectRecipientStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientStatistics)).call.apply(_ref5, [this].concat(args)));

    _this.state = { activeTab: _statistics3.recipientTabs.info };
    return _this;
  }

  (0, _createClass3.default)(ProjectRecipientStatistics, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var projectId = nextProps.projectId,
          recipientId = nextProps.recipientId,
          startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
      if (isDateChanged && startDate && endDate) {
        this.props.loadPopularityStats({ projectId: projectId, recipientId: recipientId, startDate: startDate, endDate: endDate });
        this.props.loadRecipientDetailedStats({ projectId: projectId, recipientId: recipientId, startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'onTabClick',
    value: function onTabClick(tab) {
      this.setState({ activeTab: tab });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          popularityData = _props.popularityData,
          detailedLoading = _props.detailedLoading,
          recipient = _props.recipient,
          detailedData = _props.detailedData,
          popularityLoading = _props.popularityLoading,
          referrer = _props.referrer,
          projectId = _props.projectId,
          recipientId = _props.recipientId,
          projectInfo = _props.projectInfo,
          projectInfoLoading = _props.projectInfoLoading,
          referrerRecipient = _props.referrerRecipient;
      var activeTab = this.state.activeTab;

      var isInfoTab = activeTab === _statistics3.recipientTabs.info;
      var isDetailedTab = activeTab === _statistics3.recipientTabs.detailed;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_StatisticsRecipientBackButton2.default, {
          referrer: referrer,
          projectId: projectId,
          recipientId: referrerRecipient || recipientId
        }),
        referrer !== 'recipient' && _react2.default.createElement(_StatisticsSelectedRecipientInfo2.default, {
          className: 'margin-bottom-20',
          loading: detailedLoading,
          recipient: recipient
        }),
        referrer !== 'project' && _react2.default.createElement(_StatisticsSelectedProjectInfo2.default, {
          className: 'margin-bottom-20',
          project: projectInfo,
          loading: projectInfoLoading
        }),
        _react2.default.createElement(_RecipientStatisticsTabs2.default, {
          activeTab: activeTab,
          tabClass: styles.tab,
          onClick: this.onTabClick
        }),
        _react2.default.createElement(
          _SimpleTabContent2.default,
          { className: (0, _bind2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.chartContent, isInfoTab), (0, _defineProperty3.default)(_classNames, styles.listContent, isDetailedTab), _classNames)) },
          isInfoTab && _react2.default.createElement(_PopularityChart2.default, { data: popularityData, loading: popularityLoading }),
          isDetailedTab && _react2.default.createElement(_RecipientDetailedStatsList2.default, { data: detailedData, loading: detailedLoading })
        )
      );
    }
  }]);
  return ProjectRecipientStatistics;
}(_react.Component), _class3.propTypes = {
  detailedData: _propTypes2.default.object,
  detailedLoading: _propTypes2.default.bool,
  endDate: _propTypes2.default.string,
  loadPopularityStats: _propTypes2.default.func,
  loadRecipientDetailedStats: _propTypes2.default.func,
  popularityData: _propTypes2.default.array,
  popularityLoading: _propTypes2.default.bool,
  projectId: _propTypes2.default.number,
  projectInfo: _propTypes2.default.object,
  projectInfoLoading: _propTypes2.default.bool,
  recipient: _propTypes2.default.object,
  recipientId: _propTypes2.default.number,
  referrer: _propTypes2.default.string,
  referrerRecipient: _propTypes2.default.number,
  startDate: _propTypes2.default.string
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  coverageData: {},
  detailedData: _statistics3.defaultDetailedData,
  popularityData: [],
  recipient: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onTabClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onTabClick'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ProjectRecipientStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectRecipientStatistics/ProjectRecipientStatistics.js
// module id = 2213
// module chunks = 1